/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { PaypalCreditNoticeProps } from './index';

/**
 * Base styles for the paypal credit notice component
 *
 * @param {PaypalCreditNoticeProps} props The paypal credit notice properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: PaypalCreditNoticeProps) => css`
    ${theme.typography.body_small}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * The paypal credit notice component styles
 *
 * @param {PaypalCreditNoticeProps} props The paypal credit notice properties object
 * */
export const styles = (props: PaypalCreditNoticeProps) => css`
    ${baseStyles(props)}
`;
